<template>
  <div class="container">
    <head-nav-bar title="查询结果" :fixed="true"> </head-nav-bar>
    <div class="price-query-list">
      <div class="alert">
        <span>
          <span v-if="typeId"
            >分类：<a>{{ typeName }}</a>
          </span>
          <span v-else-if="keyword"
            >关键词：<a>{{ keyword }}</a>
          </span>
          <span style="margin-left:12px"
            >共：<a>{{ total }}</a> 条数据</span
          >
        </span>
      </div>
      <div class="goods-price-list">
        <div
          class="goods-price-item"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="goods-title">{{ item.name }}</div>
          <div class="goods-info">
            <div class="goods-price">
              <price :value="item.unitPrice" size="small" />
              <span class="unit">/ {{ item.unitName }}</span>
            </div>
            <div class="goods-spec">{{ item.specifications }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Price from "@/components/price";
import { Toast } from "vant";
export default {
  components: {
    Price,
  },
  data() {
    return {
      keyword: "",
      typeId: "",
      typeName: "",
      list: [],
      total: 0,
    };
  },
  created() {
    this.keyword = this.$route.query.keyword;
    this.typeId = this.$route.query.typeId;
    this.typeName = this.$route.query.typeName;
    this.fetchData();
  },
  methods: {
    fetchData() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.$post("GoodsPrice_GetGoodsList", {
        TypeId: this.typeId,
        Keyword: this.keyword,
      }).then(res => {
        this.list = res.data;
        this.total = res.data.length;
        Toast.clear();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.price-query-list {
  margin-top: 55px;
  .alert {
    font-size: 13px;
    text-align: center;
    & > span {
      display: inline-block;
      padding: 5px 20px;
      border-radius: 20px;
      background: #e6f7ff;
    }
  }
}
.goods-price-list {
  .goods-price-item {
    font-size: 14px;
    border-bottom: 1px solid #ddd;
    padding: 10px 15px;
    .goods-title {
      margin-bottom: 5px;
    }
    .goods-info {
      color: #999;
      display: flex;
      .goods-price {
        flex: 1;
        // color: #333;
        .price {
          color: red;
        }
        .unit {
          margin-left: 5px;
        }
      }
    }
  }
}
</style>
